import React, { FC } from 'react';
import styles from './MobileSearchBar.module.scss';

type Props = {
  handleSearch: ({ key }: { key: string }) => void;
  setSearchTerm: (value: string) => void;
  submitSearch:()=>void;
  searchTerm: string;
};

const MobileSearchBar: FC<Props> = ({ handleSearch, setSearchTerm, submitSearch, searchTerm }) => {
  return (
    <div className={styles.mobileSearchBar}>
      <input
        onKeyDown={handleSearch}
        onChange={(e) => setSearchTerm(e.target.value)}
        placeholder="Suchbegriff eingeben"
        value={searchTerm}
        type="text"
      />
      <span onClick={submitSearch}>
        <i className="fa fa-search" aria-hidden="true" />
      </span>
    </div>
  );
};

export default MobileSearchBar;
